export const SCALES = {
  company: { green:['AAA','AA','A'], yellow:['B','IR','AN'], red:['C','D'] },
  person:  { green:['A','B'],        yellow:['C','IR','KS'], red:['D','E'] },
};

export const COLORS = {
  green:  '#2eba2e',
  yellow: '#c89701',
  red:    '#dd2c2c',
  default:'#494949',
};

const up = (s) => (s == null ? '' : String(s).toUpperCase().replace(/\s+/g, ''));
const toSets = (scale) => ({
  green: new Set(scale.green.map(up)),
  yellow: new Set(scale.yellow.map(up)),
  red: new Set(scale.red.map(up)),
});

const SCALE_SETS = Object.fromEntries(Object.entries(SCALES).map(([k,v]) => [k, toSets(v)]));

export function getScoreBucket(score, scale = 'company') {
  const s = up(score);
  const sets = typeof scale === 'string' ? SCALE_SETS[scale] : toSets(scale);
  if (!s || !sets) return 'default';
  if (sets.green.has(s)) return 'green';
  if (sets.yellow.has(s)) return 'yellow';
  if (sets.red.has(s)) return 'red';
  return 'default';
}

export function getScoreColor(score, scale = 'company', colors = COLORS) {
  const bucket = getScoreBucket(score, scale);
  return colors[bucket] || colors.default;
}

export function hexToRgb(hex) {
  if (!hex) return [17,17,17];
  const h = hex.replace('#','');
  const n = h.length === 3 ? h.split('').map(c => c+c).join('') : h;
  const v = parseInt(n, 16);
  return [(v>>16)&255, (v>>8)&255, v&255];
}

export function getScoreColorRGB(score, scale = 'company', colors = COLORS) {
  return hexToRgb(getScoreColor(score, scale, colors));
}
